import api from "./axiosConfig"; // Centralized axios configuration

// Get all IVA
// (2026-05-14) Req: la consulta adicional a /api/seniat/igtf solo se ejecuta
// cuando el caller la pide explicitamente (includeIgtf=true). Esto evita que
// los listados de productos (FormProducts/ListProducts) traigan IGTF como
// pseudo-categoria. Casos que SI piden IGTF:
//   - ListTaxes (menu de IVAs): muestra IGTF junto a los IVAs reales.
//   - ModalPreInvoiceItems: se usa al cargar items de proforma/factura donde
//     IGTF puede aplicar como tasa adicional.
export const getTaxCategories = async ({ includeIgtf = false } = {}) => {
  try {
    const response = await api.get("/api/config/iva-categorias");
    if (includeIgtf) {
      const responseIgtf = await api.get("/api/seniat/igtf");
      response.data.push({
        'id': 0,
        'nombre': responseIgtf.data.descripcion,
        'tasa_porcentaje': responseIgtf.data.porcentaje,
      });
    }
    return response.data; // Retorna los datos directamente
  } catch (error) {
    console.error("Error fetching tax categories:", error);
    throw error; // Lanzamos el error para que el componente lo maneje
  }
};

// Get registros de auditoria
/*export const getAuditLogs = async () => {
  try {
    const response = await api.get("/admin/logs");
    return response.data; // Retorna los datos directamente
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    throw error; // Lanzamos el error para que el componente lo maneje
  }
};*/

// Get registros de auditoria
  export const getAuditLogs = async ({ page = 1, per_page = 20, request_type=false } = {}) => {
    try {
      const endpoint = '/admin/logs?';

      const query = new URLSearchParams({
        page,
        per_page,
        ...(request_type && { request_type }),
      });

      const response = await api.get(`${endpoint}?${query.toString()}`);
      //const response = await api.get(`/admin/logs?request_type=export`);// + (request_type != false ? `?request_type=${request_type}` : ``));
      return response.data; // Retorna los datos directamente
    } catch (error) {
      console.error("Error fetching audit logs:", error);
      throw error; // Lanzamos el error para que el componente lo maneje
    }
  };

// Consultar un registro de auditoria por ID
export const showAuditLogs = async (id) => {
  try {
    const response = await api.get(`/admin/logs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al consultar el audit logs:", error);
    throw error;
  }
};

export const getWithholdings = async () => {
  try {
    const response = await api.get("/api/config/retenciones");
    return response.data; // Retorna los datos directamente
  } catch (error) {
    console.error("Error fetching retenciones:", error);
    throw error; // Lanzamos el error para que el componente lo maneje
  }
};